import React from 'react'
import RuleCreateBatchHeader from './RuleCreateBatchTable/RuleCreateBatchHeader'
import RuleCreateBatchRow from './RuleCreateBatchTable/RuleCreateBatchRow'

function RuleCreateBatchTable(props) {
    const { listRule, loading, setType, setTags, setStores, setPage, toggleSelectAll, selectedItems, isSelectedAll, updateSelectedItems, reset } = props

    return (
        <div className='RuleCreateBatchTable'>
            <table className='table table-borderless table-striped'>
                <RuleCreateBatchHeader
                    selectedItems={selectedItems}
                    isSelectedAll={isSelectedAll}
                    toggleSelectAll={toggleSelectAll}
                    listRule={listRule}
                    reset={reset}
                />
                <tbody className='RuleCreateBatchRow'>
                    {
                        !!listRule && listRule.map((item, i) => {
                            return <RuleCreateBatchRow
                                key={item._id}
                                index={i}
                                item={item}
                                setType={setType}
                                setTags={setTags}
                                setPage={setPage}
                                setStores={setStores}
                                updateSelectedItems={updateSelectedItems}
                                selectedItems={selectedItems}
                                reset={reset}
                            />
                        })
                    }
                    {
                        !loading && listRule.length === 0 &&
                        <tr>
                            <td colSpan={14}>
                                No result
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default RuleCreateBatchTable